import { FieldSchema } from "../../../Schema";

export const systemOwner: FieldSchema = {
  name: "systemOwner",
  grid: {
    displayed: true,
    order: 16,
  },
  display: {
    displayed: true,
  },
  form: { label: "System owner" },
};
